import {
  GET_CLIENTS_ERROR,
  GET_CLIENTS_SUCCEED,
  INVITE_CLIENT_ERROR,
  CLEAR_CLIENT_STATE,
  INVITE_CLIENT_SUCCEED,
  GET_CLIENTS_LOADING_STATE
} from './types';

const INITIAL_STATE = {
  clients: null,
  loadingState: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_CLIENTS_SUCCEED) {
    return { ...state, clients: action.payload, loadingState: false };
  } else if (
    action.type === GET_CLIENTS_ERROR ||
    action.type === INVITE_CLIENT_ERROR
  ) {
    return { ...state, error: action.payload, loadingState: false };
  } else if (action.type === CLEAR_CLIENT_STATE) {
    return { ...state, error: null, success: null };
  } else if (action.type === INVITE_CLIENT_SUCCEED) {
    return { ...state, success: true };
  } else if (action.type === GET_CLIENTS_LOADING_STATE) {
    return { ...state, loadingState: true };
  } else {
    return state;
  }
}
